import _ from 'lodash';

import getters from '@/store/newProject/getters';
import mutations from '@/store/newProject/mutations';
import actions from '@/store/newProject/actions';
import { emptyProject, initNewProjectNavigation } from '@/constants/projects';

const state = {
  storedNewProject: _.cloneDeep(emptyProject),
  storedNewProjectNavigation: _.cloneDeep(initNewProjectNavigation),
};

export default {
  state,
  getters,
  mutations,
  actions,
};
